import { render } from "./RequestsClient.vue?vue&type=template&id=b6838624&scoped=true"
import script from "./RequestsClient.vue?vue&type=script&lang=js"
export * from "./RequestsClient.vue?vue&type=script&lang=js"

import "./RequestsClient.vue?vue&type=style&index=0&id=b6838624&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6838624"]])

export default __exports__